module.exports = require("lodash/invokeMap");